import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import createWebStorage from 'redux-persist/lib/storage/createWebStorage'

import changeEmailSlice from './slice/change-email-slice'
import changeWithdrawalAccountSlice from './slice/change-withdrawal-account-slice'
import deleteAccountSlice from './slice/delete-account-slice'
import emailOtpSlice from './slice/email-otp-slice'
import forgotPinSlice from './slice/forgot-pin-slice'
import phoneOtpSlice from './slice/phone-otp-slice'
import pinSlice from './slice/pin-slice'
import submissionSlice from './slice/submission-slice'
import uiSlice from './slice/ui-slice'
import userSlice from './slice/user-slice'

const createNoopStorage = () => {
  return {
    getItem() {
      return Promise.resolve(null)
    },
    setItem(_key: string, value: any) {
      return Promise.resolve(value)
    },
    removeItem() {
      return Promise.resolve()
    },
  }
}

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage()

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'submission',
    'ui',
    'user',
    'forgotPin',
    'phoneOtp',
    'changeEmail',
    'notificationPostpone',
    'changeWithdrawalAccount',
    'emailOtp',
    'deleteAccount',
  ], // add reducer you want to persist here
}

const rootReducer = combineReducers({
  phoneOtp: phoneOtpSlice,
  pin: pinSlice,
  submission: submissionSlice,
  ui: uiSlice,
  user: userSlice,
  forgotPin: forgotPinSlice,
  changeEmail: changeEmailSlice,
  changeWithdrawalAccount: changeWithdrawalAccountSlice,
  emailOtp: emailOtpSlice,
  deleteAccount: deleteAccountSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NEXT_PUBLIC_APP_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
